import { render } from "./FormInputTextarea.vue?vue&type=template&id=17f69c53"
import script from "./FormInputTextarea.vue?vue&type=script&lang=js"
export * from "./FormInputTextarea.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__